import { getContext } from 'configs/context';

import pluggableApisService, { PluggableApisService } from 'services/pluggableApis';

import type { IProcessResult } from './toolchain';

const aiBackgroundProcess = async (prompt: string, itemKey: string, isCancel: () => boolean): Promise<IProcessResult> => {
  if (isCancel()) {
    throw new Error('cancelled');
  }

  const sourceUrl = await PluggableApisService.getSourceUrl(itemKey);

  const { id: userId = -1, username: userName = 'non_registered_user' } = getContext().general.auth.getState();

  const response = await pluggableApisService.requestAiBackground({ url: sourceUrl, text: prompt, count: 1, requestNumber: 1 }, userId, userName);

  const resultUrl = response.result.output_images_urls[0];
  if (!resultUrl) {
    throw new Error('AI background generation returned no images');
  }

  return { result: resultUrl };
};

export default aiBackgroundProcess;
